<template>
  <div
    :data-test="`${cyComponent}--token-profile`"
    class="desktop-table-container"
  >
    <b-table
      id="desktop-token-profile-table"
      :data="tokensForTrade.length ? tokensForTrade : [1, 2, 3, 4]"
    >
      <template slot-scope="props">
        <b-table-column
          :meta="{ key: 'code' }"
          :label="$t('exchange.token_name')"
          sortable
          field="code"
        >
          <template
            slot="header"
            slot-scope="{ column }"
          >
            <div
              :data-test="`${cyComponent}--table-header-cols-${column.meta.key}`"
              class="header-label header-hover"
            >
              <div
                :data-test="`${cyComponent}--header-text`"
                class="header-label-text"
              >
                {{ column.label }}
              </div>
              <div
                :data-test="`${cyComponent}--header-sort-arrow`"
                class="header-label-sort-arrow"
              >
                <div
                  :data-test="`${cyComponent}--sort-arrow-up`"
                  class="sort-arrow-up"
                >
                  <img :src="`${sortDetail.column === column.label && sortDetail.direction === 'up' ? '/static/svg/arrow-drop-down.svg' : '/static/svg/arrow-drop-down-inactive.svg'}`">
                </div>
                <div
                  :data-test="`${cyComponent}--sort-arrow-down`"
                  class="sort-arrow-down"
                >
                  <img :src="`${sortDetail.column === column.label && sortDetail.direction === 'down' ? '/static/svg/arrow-drop-down.svg' : '/static/svg/arrow-drop-down-inactive.svg'}`">
                </div>
              </div>
            </div>
          </template>
          <div
            v-if="tokensForTrade.length"
            class="token-name-col"
          >
            <div class="token-name-img">
              <img :src="`/static/token/normal/${props.row.code.toLowerCase()}.svg`">
            </div>
            <div class="token-name-lable">
              <div
                :data-test="`${cyComponent}--token-code`"
                class="token-name-lable-code"
              >
                {{ props.row.code }}
              </div>
              <div class="token-name-lable-fullname">
                {{ props.row.name }}
              </div>
            </div>
          </div>
          <div
            v-else
            class="token-name-col"
          >
            <b-skeleton height="30px"/>
          </div>
        </b-table-column>
        <b-table-column
          :meta="{ key: 'price' }"
          :label="$t('exchange.price_usd')"
          :custom-sort="sortByPrice"
          field="price"
          sortable
          centered
        >
          <template
            slot="header"
            slot-scope="{ column }"
          >
            <div
              :data-test="`${cyComponent}--table-header-cols-${column.meta.key}`"
              class="header-label-centered header-hover"
            >
              <div
                :data-test="`${cyComponent}--header-text`"
                class="header-label-text"
              >
                {{ column.label }}
              </div>
              <div
                :data-test="`${cyComponent}--header-sort-arrow`"
                class="header-label-sort-arrow"
              >
                <div
                  :data-test="`${cyComponent}--sort-arrow-up`"
                  class="sort-arrow-up"
                >
                  <img :src="`${sortDetail.column === column.label && sortDetail.direction === 'up' ? '/static/svg/arrow-drop-down.svg' : '/static/svg/arrow-drop-down-inactive.svg'}`">
                </div>
                <div
                  :data-test="`${cyComponent}--sort-arrow-down`"
                  class="sort-arrow-down"
                >
                  <img :src="`${sortDetail.column === column.label && sortDetail.direction === 'down' ? '/static/svg/arrow-drop-down.svg' : '/static/svg/arrow-drop-down-inactive.svg'}`">
                </div>
              </div>
            </div>
          </template>
          <div
            v-if="tokensForTrade.length"
            :data-test="`${cyComponent}--token-price`"
            class="rate-col"
          >
            ${{ props.row.price | numberWithComma }}
          </div>
          <div
            v-else
            class="rate-col"
          >
            <b-skeleton height="30px"/>
          </div>
        </b-table-column>
        <b-table-column
          :meta="{ key: 'change' }"
          :label="$t('exchange.change_24_hr')"
          :custom-sort="sortByPercentChange"
          field="change"
          sortable
          centered
          numeric
        >
          <template
            slot="header"
            slot-scope="{ column }"
          >
            <div
              :data-test="`${cyComponent}--table-header-cols-${column.meta.key}`"
              class="header-label-centered header-hover"
            >
              <div
                :data-test="`${cyComponent}--header-text`"
                class="header-label-text"
              >
                {{ column.label }}
              </div>
              <div
                :data-test="`${cyComponent}--header-sort-arrow`"
                class="header-label-sort-arrow"
              >
                <div
                  :data-test="`${cyComponent}--sort-arrow-up`"
                  class="sort-arrow-up"
                >
                  <img :src="`${sortDetail.column === column.label && sortDetail.direction === 'up' ? '/static/svg/arrow-drop-down.svg' : '/static/svg/arrow-drop-down-inactive.svg'}`">
                </div>
                <div
                  :data-test="`${cyComponent}--sort-arrow-down`"
                  class="sort-arrow-down"
                >
                  <img :src="`${sortDetail.column === column.label && sortDetail.direction === 'down' ? '/static/svg/arrow-drop-down.svg' : '/static/svg/arrow-drop-down-inactive.svg'}`">
                </div>
              </div>
            </div>
          </template>
          <div
            v-if="tokensForTrade.length"
            class="change-col"
          >
            <div
              :class="[
                'change-col-text',
                {
                  'is-green': props.row.change > 0,
                  'is-black': props.row.change === 0,
                  'is-red': props.row.change < 0
                }
              ]"
              :data-test="`${cyComponent}--price-change`"
            >
              <span v-if="props.row.change > 0">+</span>{{ props.row.change | toFixedDecimal(2) }} %
            </div>
          </div>
          <div
            v-else
            class="change-col"
          >
            <b-skeleton height="30px"/>
          </div>
        </b-table-column>
        <b-table-column
          :label="$t('exchange.buy_sell_token')"
          centered
        >
          <template
            slot="header"
            slot-scope="{ column }"
          >
            <div class="header-label-centered">
              <div
                :data-test="`${cyComponent}--header-text`"
                class="header-label-text"
              >
                {{ column.label }}
              </div>
            </div>
          </template>
          <div
            v-if="tokensForTrade.length"
            :data-test="`${cyComponent}--button-footer`"
            class="buy-sell-col"
          >
            <button
              :data-test="`${cyComponent}--buy-token-button`"
              class="button buy-sell-col-buy-btn"
              @click="onBuyClicked(props.row)"
            >
              {{ $t('exchange.buy') }}
            </button>
            <button
              :data-test="`${cyComponent}--sell-token-button`"
              class="button buy-sell-col-sell-btn"
              @click="onSellClicked(props.row)"
            >
              {{ $t('exchange.sell') }}
            </button>
          </div>
          <div
            v-else
            class="skt-col"
          >
            <div class="btn-skt"><b-skeleton height="50px"/></div>
            <div class="btn-skt"><b-skeleton height="50px"/></div>
          </div>
        </b-table-column>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: 'DesktopTable',
  props: {
    tokensForTrade: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      sortDetail: {
        column: 'Token name',
        direction: 'down'
      },
      cyComponent: 'desktop-table'
    }
  },
  methods: {
    onBuyClicked (target) {
      this.$emit('buyEvent', target)
    },
    onSellClicked (source) {
      this.$emit('sellEvent', source)
    },
    sortByPrice (a, b, isAsc) {
      if (isAsc) {
        return b.price - a.price
      } else {
        return a.price - b.price
      }
    },
    sortByPercentChange (a, b, isAsc) {
      if (isAsc) {
        return b.change - a.change
      } else {
        return a.change - b.change
      }
    }
  }
}
</script>

<style>
#desktop-token-profile-table .table-wrapper table thead tr th .th-wrap .icon {
  display: none;
}
</style>

<style scoped lang="scss">
.table th, .table td {
  width: 20% !important;
}
.desktop-table-container {
  float: left;
  width: 100%;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
}
.header-label {
  height: 50px;
  width: 100%;
  font-family: Roboto;
  font-size: 15px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.4px;
  color: #a1a1a1;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding-left: 50px;
}
.header-label-centered {
  height: 50px;
  width: 100%;
  font-family: Roboto;
  font-size: 15px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.4px;
  color: #a1a1a1;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}
.header-label-text {
  float: left;
}
.header-label-sort-arrow {
  float: left;
  position: relative;
  width: 15px;
  height: 15px;
  margin-left: 10px;
}
.sort-arrow-up {
  width: 10px;
  transform: rotate(180deg);
  position: absolute;
  left: 0px;
  top: -2px;
}
.sort-arrow-down {
  width: 10px;
  position: absolute;
  position: absolute;
  left: 0px;
  top: 3px;
}
.header-hover:hover {
  cursor: pointer;
}
.token-name-col {
  float: left;
  width: 100%;
  height: 90px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: 10px;
  padding-left: 50px;
}
.token-name-img {
  float: left;
  height: 40px;
  width: 40px;
  padding: 5px;
}
.token-name-lable {
  float: left;
  margin-left: 10px;
  width: calc(100% - 50px);
}
.token-name-lable-fullname {
  font-family: Roboto;
  font-size: 14px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.3px;
  color: #363636;
}
.token-name-lable-code {
  font-family: Roboto;
  font-size: 20px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.5px;
  color: #363636;
}
.change-col {
  float: left;
  width: 100%;
  height: 90px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
}
.change-col-text {
  font-family: DINAlternate !important;
  font-size: 20px;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  font-weight: 500;
}
.is-red {
  color: #e90000;
}
.is-green {
  color: #3eaf34;
}
.is-black {
  color: #000000;
}
.rate-col {
  float: left;
  width: 100%;
  height: 90px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  font-family: DINAlternate !important;
  font-size: 20px;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  color: #00aeff;
  font-weight: 500;
}
.volume-col{
  float: left;
  width: 100%;
  height: 90px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  font-family: DINAlternate !important;
  font-size: 20px;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  color: #3b3b3b;
  font-weight: 500;
}
.buy-sell-col {
  float: left;
  width: 100%;
  height: 90px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 10px;
}
.skt-col {
  width: 100%;
  height: 90px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  .btn-skt {
    width: 80px;
  }
}
.buy-sell-col-buy-btn {
  max-width: 83px;
  min-width: 55px;
  width: 40%;
  height: 40px;
  border-radius: 3px;
  border: solid 1px #3eaf34;
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.1px;
  color: #3eaf34;
}
.buy-sell-col-buy-btn:hover{
  cursor: pointer;
}
.buy-sell-col-sell-btn {
  height: 40px;
  max-width: 83px;
  min-width: 55px;
  width: 40%;
  border-radius: 3px;
  border: solid 1px #e90000;
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.1px;
  color: #e90000;
}
.buy-sell-col-sell-btn:hover{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/features/TokenProfile/components/DesktopTable.vue